<div fxLayout="column" fxLayoutAlign="center center" class="main-container">
    <h1>Admin/Dev Tools</h1>
    <div class="instruction-text">
        This section contains developer and administrator tools, use with care.
    </div>

    <div class="tool-container">
        <p><strong>Account Data</strong></p>
        <p>Used for administrating the bank account data service including the data that comes in from account data providers.</p>
        <button mat-raised-button color="primary" [disabled]="isExecutingFullRescync" [class.spinner]="isExecutingFullRescync" (click)="onClickExecuteFullResync()">{{isExecutingFullRescync ? 'Requesting...' : 'Full Resync'}}</button>
    </div>
</div>

